var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"uk-section"},[_c('slider-show'),_c('ArticlesList',{staticStyle:{"margin-top":"20px"},attrs:{"articles":_vm.portadas}}),_c('LogosList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }